import { ProgCss } from "./ProgCss.Generated";

let eventHandlersWiredUp = false;

export function WireUpWarningBars() { EnsureWarningBarContainer(); }

function EnsureWarningBarContainer(): HTMLElement {
    if (!eventHandlersWiredUp) {
        eventHandlersWiredUp = true;
        document.documentElement.addEventListener('click', WarningBarClick);
    }

    const existingContainer = document.querySelector(`.${ProgCss.WarningBar_container}`);
    if (existingContainer instanceof HTMLElement) {
        return existingContainer;
    }
    const container = document.createElement('div');
    container.className = ProgCss.WarningBar_container;
    document.body.append(container);
    for (const warningBar of document.querySelectorAll(`.${ProgCss.WarningBar}`)) {
        if (!container.contains(warningBar)) {
            container.append(warningBar);
        }
    }

    return container;
}

function WarningBarClick(e: MouseEvent, onClose?: () => void) {
    if (e.target instanceof Element) {
        const warningBar = e.target.closest(`.${ProgCss.WarningBar}`);
        if (warningBar instanceof HTMLElement) {
            warningBar.remove();
            e.stopPropagation();
            e.preventDefault();
            if (onClose) {
                onClose();
            }
        }
    }
}

export function ShowWarningBar(warningMessage: string, onClose?: () => void) {
    const warningClose = document.createElement('span');
    warningClose.className = ProgCss.WarningBar_close;
    warningClose.append('×');
    const warningBar = document.createElement('div');
    warningBar.className = ProgCss.WarningBar;
    warningBar.append(warningMessage, warningClose);
    EnsureWarningBarContainer().append(warningBar); //tevens ook init!
    warningBar.addEventListener('click', e => WarningBarClick(e, onClose));
}
